// AUTO-GENERATED by scripts/generate-catalog-visibility.mjs. Do not edit by hand.
// Regenerated by `npm run predev` / `npm run prebuild`.
//
// Maps each `x-og-visibility` level to the Zudoku operation slugs annotated
// with it. Consumed by the catalog visibility gate to cosmetically hide those
// operations from users who do not belong to the level's audience.

export const CATALOG_VISIBILITY_SLUGS: Record<string, readonly string[]> = {
  "superuser": [
    "archive-a-record-type",
    "clone-a-record-type",
    "create-a-record-type",
    "restore-a-record-type",
    "update-a-record-type"
  ]
};
